import { gql } from "@apollo/client";

export const IS_GUIDE_INVOICE_SUBMISSION_OPEN = gql`
    query isGuideInvoiceSubmissionOpen {
        isGuideInvoiceSubmissionOpen
    }
`;

export const GET_GUIDE_INVOICE_SUBMISSION_PERIOD = gql`
    query getGuideInvoiceSubmissionPeriod {
        getGuideInvoiceSubmissionPeriod {
            month
            year
        }
    }
`;

export const GET_MY_GUIDE_INVOICES = gql`
    query getMyGuideInvoices {
        getMyGuideInvoices {
            _id
            month
            year
            originalFileName
            createdAt
            guide {
                _id
                profile {
                    firstName
                    lastName
                }
            }
        }
    }
`;

export const GET_GUIDE_INVOICES = gql`
    query getGuideInvoices($month: Int!, $year: Int!) {
        getGuideInvoices(month: $month, year: $year) {
            _id
            month
            year
            originalFileName
            createdAt
            guide {
                _id
                profile {
                    firstName
                    lastName
                }
            }
        }
    }
`;

export const DELETE_GUIDE_INVOICE = gql`
    mutation deleteGuideInvoice($id: String!) {
        deleteGuideInvoice(id: $id)
    }
`;
